import React from 'react'
import { FormattedDate, FormattedTime, useIntl } from 'react-intl'
import { selectUnit } from '@formatjs/intl-utils'
import Icon from 'components/Icon'
import { MarkdownViewer } from '@arnsbogroup/react-voicearchive'

const Message = ({ by, timestamp, body, title, last }) => {
  const {
    name = 'Unknown',
    email = 'support@voicearchive.com',
    image = 'https://voicearchive-branding.s3.eu-central-1.amazonaws.com/avatar-fallback.jpg',
  } = by || {}

  return (
    <li>
      <div className="relative pb-8">

        { !last &&
          <span className="absolute top-5 left-5 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true"></span>
        }

        <div className="relative flex items-start space-x-3">
          <div className="relative">
            <img className="h-10 w-10 rounded-full bg-gray-400 flex items-center justify-center ring-8 ring-white" src={image} alt="" />

            <span className="absolute -bottom-0.5 -right-1 text-primary px-0.5 py-px">
              <Icon icon="comment-lines" />
            </span>
          </div>
          <div className="min-w-0 flex-1">
            <div>
              <div className="text-sm">
                <a href="#" className="font-medium text-gray-900">{ name }</a>
              </div>
              <p className="mt-0.5 text-xs text-gray-500">
                <FormattedDate value={timestamp * 1000} /> <FormattedTime value={timestamp * 1000} />
              </p>
            </div>
            <div className="mt-2 text-sm text-gray-700">
              <MarkdownViewer>
                {body}
              </MarkdownViewer>
            </div>
          </div>
        </div>
      </div>
    </li>
  )
}

export default Message
